import shortenString from './shorten-string'

export default function displayProfileName (firstName) {
  let names = firstName.split(' ')
  let displayedName = ''

  if (names[0].length >= 16) return shortenString(names[0], 16)

  for (const name of names) {
    if ((name + displayedName).length >= 17) break

    displayedName += `${name} `
  }

  return displayedName.slice(0, -1)
}
